export default (commonBasicPlanCheckout) =>
  ({ planSelectionPath, paymentsPath, isTrackVisitCheckout, isAbandonedBasket } = {}) => ({
    // Init basic common checkout functionality

    ...commonBasicPlanCheckout({
      planSelectionPath,
      paymentsPath,
      isTrackVisitCheckout,
      isAbandonedBasket,
    }),

    // Add brand-specific checkout functionality or overwrite common

    init() {
      this.commonInit()
    },

    submitOffer() {
      this.store.internalTracker.setEventToSessionStorage({ clickName: "Get Plan Clicked" })
      this.commonSubmitOffer()
    },
  })
